/*    
<summary>
  This functional component "AgreementSignPopupHOC" provides props to the child component.
  1. State "showAgreementSignPopup" that manages the show/hide of pop up
  2. Function "agreementSignPopupToggleHandler" to toggle the show/hide popup state "showAgreementSignPopup"
  Developer:Aashish Singh, Created Date:19-April-2025
</summary>
<returns>Returns JSX</returns>
*/
import React, { useState } from "react";

const AgreementSignPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showAgreementSignPopup, setShowAgreementSignPopup] = useState<boolean>(false);

    const agreementSignPopupToggleHandler = () => {
      setShowAgreementSignPopup(!showAgreementSignPopup);
    };

    return (
      <Component
        showAgreementSignPopup={showAgreementSignPopup}
        agreementSignPopupToggleHandler={agreementSignPopupToggleHandler}
        {...props}
      />
    );
  };

export default AgreementSignPopupHOC;
